import Link from 'components/Link';
import type { FC, ReactNode } from 'react';
import type { TranslationProps } from './types';
import useTranslation from './useTranslation';

import styles from './styles.module.scss';

const LINK_REGEX = /\[([^\]]+)\]\((\/[^\s)]+|https?:\/\/[^\s)]+)\)/g;

const TranslationWithLinks: FC<TranslationProps> = ({ message, params }) => {
  const elements: ReactNode[] = [];
  let lastIndex = 0;
  const translation = useTranslation(message, params);
  const matches = [...translation.matchAll(LINK_REGEX)];

  if (matches.length === 0) {
    return translation;
  }

  for (const match of matches) {
    const [fullMatch, anchorText, url] = match;
    const matchIndex = match.index;

    if (matchIndex > lastIndex) {
      elements.push(translation.slice(lastIndex, matchIndex));
    }

    elements.push(
      url.startsWith('/') ? (
        <Link className={styles.link} to={url} key={matchIndex}>
          {anchorText}
        </Link>
      ) : (
        <a
          className={styles.link}
          href={url}
          key={matchIndex}
          target="_blank"
          rel="noopener noreferrer"
        >
          {anchorText}
        </a>
      ),
    );

    lastIndex = matchIndex + fullMatch.length;
  }

  if (lastIndex < translation.length) {
    elements.push(translation.slice(lastIndex));
  }

  return <span className={styles['link-wrapper']}>{elements}</span>;
};

export default TranslationWithLinks;
